document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-video-toggle]').forEach((button) => {
    const video = document.getElementById(button.dataset.videoTarget);
    if (!video) return;

    const pauseIcon = button.querySelector('[data-icon-pause]');
    const playIcon = button.querySelector('[data-icon-play]');

    const updateState = (playing) => {
      pauseIcon.classList.toggle('hidden', !playing);
      playIcon.classList.toggle('hidden', playing);
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    };

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', () => updateState(true));
    video.addEventListener('pause', () => updateState(false));

    updateState(!video.paused);
  });
});
